export const visit = (vm, at) => {
at({ "ru": { "conversationsVisitorUIPageTitleNotifications": { "newMessage": "\u041D\u043E\u0432\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435" } } });
};